import React from "react";
import { Button, Card, Col, Form, Input, Row, Checkbox, Alert } from "antd";
import { UserOutlined, LockOutlined } from '@ant-design/icons';

class Login extends React.Component {
    constructor(props){
        super(props)
    }
    state={}
    componentDidMount(){}
    onFinish = (e) => {
        //console.log('those are form values: ', e)
        this.props.onLogin(e.username, e.password)
    }
    render(){
        return(
            <div>
                <Row>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}
                        style={{background: 'white'}}
                    >
                        <Card
                            className="login-form"
                        >
                            <div className="login-header">
                                <UserOutlined /> Login
                            </div>
                            {this.props.authFail ? <Alert message={this.props.authFailMsg} type="error" showIcon /> : null}
                            <Form
                                name="normal_login"
                                style={{marginTop: '10px'}}
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={this.onFinish}
                                >
                                     <strong>Username</strong>
                                <Form.Item
                                
                                    name="username"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Username!',
                                    },
                                    ]}
                                   
                                >
                                    <Input size="large" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" style={{ borderRadius: "30px" }}  />
                                </Form.Item>
                                <strong>Password</strong>
                                <Form.Item
                                    name="password"
                                    style={{marginTop: '10px'}}
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Password!',
                                    },
                                    ]}
                                >
                                    <Input.Password size="large"
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    placeholder="Password"
                                    style={{ borderRadius: "30px" }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    style={{marginTop: '10px'}}
                                >
                                    <Form.Item name="remember" valuePropName="checked" noStyle>
                                    <Checkbox>Remember me</Checkbox>
                                    </Form.Item>

                                    <a className="login-form-forgot" href="#">
                                    Forgot password
                                    </a>
                                </Form.Item>

                                <Form.Item
                                    style={{marginTop: '10px'}}
                                >
                                    <Button type="primary" htmlType="submit" className="login-form-button">
                                    Submit
                                    </Button>
                                   
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                </Row>
            </div>
        )
    }
}

export default Login;